import { render, staticRenderFns } from "./FilePicker.vue?vue&type=template&id=0bd01bec&scoped=true&"
import script from "./FilePicker.vue?vue&type=script&lang=js&"
export * from "./FilePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd01bec",
  null
  
)

export default component.exports